import capitalize from 'lodash/capitalize'

export const formattedPercentage = (val?: number, maximumFractionDigits = 1) => ((val ?? 0) * 100).toLocaleString('no-NO', { maximumFractionDigits }) + ' %'

export const capitalizeWords = (value: string): string => value.split(' ').map(capitalize).join(' ')
